import React from 'react'
import Grid from "@mui/material/Grid"
import {Box, Typography, Paper, IconButton} from '@mui/material'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

let isBackShowing: boolean = true

let isFrontImage: boolean = true


export default function CardPage() {
  return (
    <>
      <Grid sx={{mt: 1}} container direction="row" justifyContent='center'>
        <Grid item xs={0} sm={1} md={3.5}/>
        <Grid item xs={true} sm={10} md={5} sx={{textAlign: "center"}}>
          <Card sx={{mt: 2}}>
            {
              isFrontImage ?
                <CardMedia
                  sx={{
                    px: 2,
                    pt: 2,
                  }}
                  component="img"
                  alt="front image"

                  image='https://picsum.photos/600/400'
                /> : null
            }
            <CardContent sx={{textAlign: "left"}}>

              <Typography variant="body1" color="text.secondary">
                Lizards are a widespread group of squamate reptiles, with over 6,000
                species, ranging across all continents except Antarctica
              </Typography>
            </CardContent>
            {
              isBackShowing ?
                null :
                <CardActions sx={{justifyContent: 'space-between'}}>
                  <IconButton>
                    <ArrowBackIosIcon/>
                  </IconButton>
                  <Button variant="outlined" size="small">Show Answer</Button>
                  <IconButton>
                    <ArrowForwardIosIcon/>
                  </IconButton>
                </CardActions>}
          </Card>
          {
            isBackShowing ?

              <Card sx={{mt: 2}}>
                <CardMedia
                  sx={{
                    px: 2,
                    pt: 2,
                  }}
                  component="img"
                  alt="front image"

                  image='https://picsum.photos/600/400'
                />
                <CardContent sx={{textAlign: "left"}}>

                  <Typography variant="body1" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with over 6,000
                    species, ranging across all continents except Antarctica
                  </Typography>
                </CardContent>
                <CardActions sx={{justifyContent: 'space-between'}}>
                  <IconButton>
                    <ArrowBackIosIcon fontSize='large'/>
                  </IconButton>
                  <Button variant="outlined" size="small">Show Answer</Button>
                  <IconButton>
                    <ArrowForwardIosIcon fontSize='large'/>
                  </IconButton>
                </CardActions>
              </Card> : null}
          {
            isBackShowing ? <Box>got it?</Box> : null}
        </Grid>

        <Grid item xs={0} sm={1} md={3.5}/>
      </Grid>

    </>
  )
}
